export default __webpack_public_path__ + "static/media/flixer.eb5674b3.png";